import CoreBanner, { type BannerProps } from '@ovpn/ui/banner';

import { boxed } from '@sso/shared/hocs';

function Banner({ persistent = true, ...props }: BannerProps) {
    return <CoreBanner persistent={persistent} {...props} />;
}

export default boxed(Banner);
